<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile ">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <div class="row center">
                        <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name" filter
                                  :placeholder="$t('AppVehiclesGroup.Organização')" class="auto-center" dataKey="id"
                                  style="width: 250px" @input="saveChosenOptionsToLocalStorage"/>
                    </div>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div class="d-flex justify-content-center mt-4">
                    <div class="col-6 bg-white rounded-lg p-4">
                        <AppVehiclesGroupTable v-if="selectedOrg" :loading="loading" :vehicles-groups="vehiclesGroups"
                                               @add="add" @edit="edit" @remove="remove"/>
                    </div>
                </div>
            </div>
        </div>

        <Dialog :visible.sync="showEditVehiclesGroup" modal :contentStyle="{width: '500px'}">
            <template #header>
                <div style="font-size: larger; font-weight: bold" class="pl-3">
                    {{ isEditing ? $t('AppVehiclesGroup.Editando frente: ') + selectedVehiclesGroup.name : $t('AppVehiclesGroup.Adicionar frente') }}
                </div>
            </template>
            <div class="d-flex flex-column align-items-center dialog-size">
                <InputText v-model="vehiclesGroupName" :placeholder="$t('AppVehiclesGroup.Nome da frente')" class="mb-3"
                           style="width: 80%"/>
            </div>
            <template #footer>
                <Button :label="$t('AppVehiclesGroup.Cancelar')" @click="closeDialog" class="p-button-secondary"/>
                <Button :label="$t('AppVehiclesGroup.Salvar')" @click="save" class="p-button-info"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="showConfirmRemove" modal>
            <template #header>
                <div style="font-size: larger; font-weight: bold" class="pl-3">
                    {{ $t('AppVehiclesGroup.Tem certeza que deseja remover esta frente?') }}
                </div>
            </template>
            <div class="d-flex flex-column align-items-center dialog-size">
            </div>
            <template #footer>
                <Button :label="$t('AppVehiclesGroup.Não')" @click="closeDialog" class="p-button-secondary"/>
                <Button :label="$t('AppVehiclesGroup.Sim')" @click="removeVehiclesGroup" class="p-button-info"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import AppVehiclesGroupTable from './AppVehiclesGroupTable.vue';

import OrganizationsService from '@/services/OrganizationsService';
import VehiclesGroupService from '@/services/VehiclesGroupService';

export default {
    mounted() {
        this.organizationsService = new OrganizationsService();
        this.vehiclesGroupService = new VehiclesGroupService();

        this.getOrganizations();
    },
    data() {
        return {
            organizationsService: null,
            vehiclesGroupService: null,
            selectedOrg: null,
            loadingOrganizations: false,
            loading: false,
            organizations: [],
            vehiclesGroups: [],
            isEditing: false,
            showEditVehiclesGroup: false,
            showConfirmRemove: false,
            selectedVehiclesGroup: null,
            vehiclesGroupName: null
        }
    },
    methods: {
        getOrganizations() {
            this.loadingOrganizations = true;
            this.organizationsService.getAllV3('VEHICLES')
                .then(response => {
                    this.organizations = response;
                    this.loadFilteredOptions();
                })
                .catch(() => {
                    this.goBack();
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesGroup.Não foi possível buscar as organizações'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingOrganizations = false;
                })
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.organizations.filter(a => this.storedChosenOptions['clients'].some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        getOrganizationGroups() {
            this.loading = true;
            this.vehiclesGroupService.getOrganizationsGroups(this.selectedOrg.id)
                .then(response => {
                    this.vehiclesGroups = response;
                })
                .catch(() => {
                    this.goBack();
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesGroup.Não foi possível buscar as frentes de trabalho da organização'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        add() {
            this.isEditing = false;
            this.vehiclesGroupName = null;
            this.showEditVehiclesGroup = true;
        },
        edit(vehiclesGroup) {
            this.isEditing = true;
            this.vehiclesGroupName = vehiclesGroup.name;
            this.showEditVehiclesGroup = true;
            this.selectedVehiclesGroup = vehiclesGroup;
        },
        save() {
            if (!this.vehiclesGroupName) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppVehiclesGroup.Favor preencher o campo de nome da frente de trabalho'),
                    life: 5000
                });
                return;
            }

            let body = {
                id: this.isEditing ? this.selectedVehiclesGroup.id : this.selectedOrg.id,
                name: this.vehiclesGroupName
            }

            if (this.isEditing) {
                this.editVehiclesGroup(body);
                return;
            }

            this.createNewGroup(body);
        },
        editVehiclesGroup(body) {
            this.vehiclesGroupService.updateVehiclesGroup(body)
                .then(() => {
                    this.closeDialog();
                    this.getOrganizationGroups();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesGroup.Nao foi possível editar a frente de trabalho'),
                        life: 5000
                    });
                })
        },
        createNewGroup(body) {
            this.vehiclesGroupService.createVehiclesGroup(body)
                .then(() => {
                    this.closeDialog();
                    this.getOrganizationGroups();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesGroup.Nao foi possível criar a frente de trabalho'),
                        life: 5000
                    });
                })
        },
        remove(vehiclesGroup) {
            this.selectedVehiclesGroup = vehiclesGroup;
            this.showConfirmRemove = true;
        },
        removeVehiclesGroup() {
            this.vehiclesGroupService.removeVehiclesGroup(this.selectedVehiclesGroup.id)
                .then(() => {
                    this.closeDialog();
                    this.getOrganizationGroups();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesGroup.Nao foi possível remover a frente de trabalho'),
                        life: 5000
                    });
                });
        },
        closeDialog() {
            this.showEditVehiclesGroup = false;
            this.showConfirmRemove = false;
        },
        goBack() {
            this.$router.go(-1);
        }
    },
    watch: {
        selectedOrg: function () {
            this.getOrganizationGroups();
        }
    },
    components: {Dropdown, Dialog, InputText, Button, AppVehiclesGroupTable}
}
</script>

<style>

</style>
